import React from 'react';
import { Link } from 'react-router-dom';
import {
    Gauge,
    TrendingUp,
    Wrench,
    ClipboardCheck,
    AlertCircle,
    Eye,
    AlertTriangle,
    HelpCircle,
    ListChecks,
    Lightbulb,
    Users,
    ChevronRight
} from 'lucide-react';
import { SEMANTIC_SUCCESS_MID } from '../../../theme/chartColors';
import './CoreModules.css';

const modulesData = [
    {
        id: 1,
        category: 'Operations',
        title: 'OEE Monitoring',
        description: 'Gain real-time visibility into Availability, Performance & Quality to pinpoint hidden losses and drive measurable uptime improvement.',
        icon: <Gauge size={24} />,
        accent: '#f97316',
        path: '/oee-loss-analysis'
    },
    {
        id: 2,
        category: 'Performance',
        title: 'Loss Analysis',
        description: 'Utilize the 16 Big Losses framework to systematically identify and eliminate chronic and sporadic losses, maximizing production throughput.',
        icon: <TrendingUp size={24} />,
        accent: '#6366f1',
        path: '/oee-loss-analysis'
    },
    {
        id: 3,
        category: 'Operations',
        title: 'Planned Maintenance',
        description: 'Shift from reactive to proactive maintenance with PM schedules and checklists, extending asset life and drastically reducing breakdowns.',
        icon: <Wrench size={24} />,
        accent: '#f97316',
        path: '/planned-maintenance'
    },
    {
        id: 4,
        category: 'Excellence',
        title: 'Audit Management',
        description: 'Conduct structured 5S and TPM audits with digital scoring to ensure compliance, track improvement trends, and drive shop floor accountability.',
        icon: <ClipboardCheck size={24} />,
        accent: '#a78bfa',
        path: '/audit-management'
    },
    {
        id: 5,
        category: 'Safety',
        title: 'Incident Management',
        description: 'Digitize your safety lifecycle from incident reporting to closure, integrating DuPont workflows and corrective actions for full accountability.',
        icon: <AlertCircle size={24} />,
        accent: '#ef4444',
        path: '/incident-management'
    },
    {
        id: 6,
        category: 'Safety',
        title: 'Safety Observation',
        description: 'Enable behavioral safety observations (BBS) to proactively capture unsafe acts and conditions, preventing future incidents.',
        icon: <Eye size={24} />,
        accent: SEMANTIC_SUCCESS_MID,
        path: '/safety-observation'
    },
    {
        id: 7,
        category: 'Safety',
        title: 'Hazard Reporting',
        description: 'Empower every worker with easy mobile-first hazard identification, driving proactive risk elimination across the plant.',
        icon: <AlertTriangle size={24} />,
        accent: SEMANTIC_SUCCESS_MID,
        path: '/hazard-reporting'
    },
    {
        id: 8,
        category: 'Performance',
        title: 'Why-Why Analysis',
        description: 'Conduct structured 5-Why root cause analysis to drill down to the true causes of failures and incidents, preventing recurrence.',
        icon: <HelpCircle size={24} />,
        accent: '#6366f1',
        path: '/rca-capa'
    },
    {
        id: 9,
        category: 'Excellence',
        title: 'CAPA System',
        description: 'Track Corrective and Preventive Actions with clear ownership and deadlines, closing the loop on findings and ensuring accountability.',
        icon: <ListChecks size={24} />,
        accent: '#a78bfa',
        path: '/rca-capa'
    },
    {
        id: 10,
        category: 'Excellence',
        title: 'Kaizen Management',
        description: 'Capture and track continuous improvement ideas to engage your workforce and build a culture of daily incremental enhancement.',
        icon: <Lightbulb size={24} />,
        accent: '#a78bfa'
    },
    {
        id: 11,
        category: 'Operations',
        title: 'One Point Lesson',
        description: 'Standardize best practices and accelerate operator skill development through bite-sized, visual knowledge sharing directly on the shop floor.',
        icon: <Users size={24} />,
        accent: '#f97316'
    }
];

const CoreModules = () => {
    return (
        <section id="core-modules" className="modules-section">
            {/* <div className="modules-glow-orb orb-1"></div>
            <div className="modules-glow-orb orb-2"></div> */}

            <div className="container">
                <div className="modules-header">
                    <div className="sec-tag">Digital Core</div>
                    <h2 className="hero-title">Intelligent <span className="gradient-text">Operations Suite</span></h2>
                    <p>
                        A powerhouse of integrated modules designed to unify your factory floor data and drive global manufacturing excellence.
                    </p>
                </div>

                <div className="modules-grid">
                    {modulesData.map((mod) => (
                        <div
                            key={mod.id}
                            className="module-box"
                            style={{ '--accent-color': mod.accent }}
                        >
                            <div className="card-glass-effect"></div>
                            <div className="card-content">
                                <div className="card-top">
                                    <div className="category-tag">{mod.category}</div>
                                    <div className="card-icon">
                                        {mod.icon}
                                    </div>
                                </div>
                                <div className="card-info">
                                    <h3>{mod.title}</h3>
                                    <p>{mod.description}</p>
                                </div>
                                <div className="card-footer">
                                    {mod.path ? (
                                        <Link to={mod.path} className="learn-more">
                                            Explore <ChevronRight size={14} />
                                        </Link>
                                    ) : (
                                        <span className="learn-more">
                                            Explore <ChevronRight size={14} />
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CoreModules;
